'use client';

import React from 'react';
import { ArrowLeft, X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { IconCurrentLocation } from "@/templates/Heritage/utils/icons";
import { useKrpano } from '@/contexts/KrpanoProvider';
import { sanitizeHtml } from '@/utils/sanitize-html';

export interface LocationItem {
    id: string;
    title: string;
    description?: string;
    image?: string;
    address?: string;
    [key: string]: any;
}

interface LocationDetailProps {
    location: LocationItem;
    onBack: () => void;
    onGoToLocation: (sceneName: string) => void;
    className?: string; // Add className prop for flexible styling
}

export default function LocationDetail({
    location,
    onBack,
    onGoToLocation,
    className = ''
}: LocationDetailProps) {
    const t = useTranslations();
    const { currentScene } = useKrpano();
    return (
        <div
            className={`flex flex-col border-t border-[var(--gen-outline)] lg:border-none bg-white lg:w-full max-h-[45vh] lg:max-h-full overflow-y-auto shadow-lg lg:shadow-none ${className}`}
            style={{ overscrollBehavior: 'contain', WebkitOverflowScrolling: 'touch' } as React.CSSProperties}
        >
            {/* Header Detail */}
            <div className="hidden lg:flex items-center px-4 py-3 border-b border-gray-100">
                <button onClick={onBack} className="mr-3 p-1 hover:bg-gray-100 rounded-full transition-colors">
                    <ArrowLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-semibold text-gray-800 line-clamp-1">{location?.title}</h2>

            </div>

            {/* Content */}
            <div
                className="flex-1 overflow-y-auto p-4"
                style={{ overscrollBehavior: 'contain' }}
            >
                {location?.thumbnail && (
                    <div className="w-full h-[150px] lg:h-[200px] mb-3 relative">
                        <img
                            src={location?.thumbnail}
                            alt={location?.title}
                            className="w-full h-full object-cover rounded-lg"
                        />

                        {
                            location?.name == currentScene && (
                                <div className="absolute top-2 left-2 p-2 w-fit rounded-xl h-[45px] bg-[var(--gen-bg-primary)] text-[#38C348] flex items-center justify-center">
                                    <IconCurrentLocation style={{ width: '12px', height: '12px' }} />
                                    <span className="text-[13px] font-semibold ml-2">{t('GROUPVIEW_POSITION') || 'Vị trí hiện tại'}</span>
                                </div>
                            )
                        }
                    </div>
                )}

                <h1 className="text-xl font-bold text-[var(--gen-label)] break-words">{location?.title}</h1>

                <div className="py-3 border-t border-gray-100 bg-white lg:border-none">
                <button
                    onClick={() => onGoToLocation(location?.name)}
                    className="w-full bg-[var(--button-secondary-bg-active)] text-[var(--button-secondary-label-active)] font-bold py-3 px-4 rounded-[10px] transition-colors shadow-md active:scale-[0.98] transform"
                >
                    {t('GO_TO_LOCATION') || 'Đi tới địa điểm'}
                </button>
            </div>


                {location?.information ? (
                    <div
                        className="text-[var(--gen-label)] text-sm leading-relaxed break-words"
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(location.information) }}
                    />
                ) : location?.group_information && location?.group_information?.information ? (
                    <div
                        className="text-[var(--gen-label)] text-sm leading-relaxed break-words"
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(location?.group_information?.information) }}
                    />
                ) : ""}

                {/* {location?.address && (
                        <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 mb-4">
                            <p className="text-sm text-gray-500 font-medium">
                                {t('ADDRESS') || 'Địa chỉ'}: {location?.address}
                            </p>
                        </div>
                    )} */}
            </div>

            {/* Footer Action */}
            {/* <div className="px-4 py-3 border-t border-gray-100 bg-white lg:border-none">
                <button
                    onClick={() => onGoToLocation(location?.name)}
                    className="w-full bg-[var(--button-secondary-bg-active)] text-[var(--button-secondary-label-active)] font-bold py-3 px-4 rounded-[10px] transition-colors shadow-md active:scale-[0.98] transform"
                >
                    {t('GO_TO_LOCATION') || 'Đi tới địa điểm'}
                </button>
            </div> */}
        </div>
    );
}
